// 引入通用common
// import commons from '@/util/commons';
// import { EventBus } from '@/util/eventBus'; // 引入事件总线
import {
  apiActivityinfoalls,
  apiApilogincalculatetokenid, apiApilogincodecollate, apiApiloginDcmoneycollate,
  apiArticleinfo,
  apiArticlelists,
  apiBillsinfo,
  apiCalculatepayaddcar,
  apiCalculatepaydata,
  apiCalculatepaysetaddcar, apiCrmdatacashbacklists, apiCrmdatacashbackloglists,
  apiCrmdatamessagelists,
  apiDealercollectenter,
  apiGoodsgrouplists,
  apiGoodsinfo,
  apiGoodslists,
  apiGoodsnav,
  apiGroupgoodsinfo,
  apiHomeindex,
  apiInvoiceapply,
  apiInvoiceinfo,
  apiInvoicelists,
  apiMapdata,
  apiOrdercatalog, apiOrdercataloginfo, apiOrdercataloglists,
  apiOrdercatalogstate,
  apiOrderdetailinfo,
  apiOrderinfo,
  apiOrderinfocalculate,
  apiOrderinfolists,
  apiPaypalurl,
  apiProduct,
  apiSaveheadportrait,
  apiSaveinfoname,
  apiSaveinvoiceinfo,
  apiSavepwd,
  apiSendcode,
  apiUserlogin,
  apiWarehousebillsgoods,
  apiWarehousebillsgoodscalculate,
  apiWarehousebillsgoodslists,
  apiWechatpay
} from '../request/api';
import commons from '@/util/commons';
import * as types from '@/store/types';

export default {
  // 登录接口
  apiUserlogin(that, ob) {
    return apiUserlogin(ob).then((ob) => {
      // console.log(ob);
      if (ob.state === 200) {
        // 初始化时间戳
        let times;
        // 执行写入本地 保持登录1天
        if (that.isCheck) {
          // 保持7天
          times = 60 * 60 * 24 * 7 * 1000;
          // times = 60 * 60 * 24 * 1000;
        } else {
          // 保持1天
          times = 60 * 60 * 24 * 1000;
        }
        // 写入缓存
        const result = commons.saveTodos('localUser', ob.data, times, 0);
        // 存储结果
        if (result) {
          // 更新本地路由的登录信息
          that.$store.commit(types.SAVE_LOCALUSER, { bool: true });
          // 跳转路由
          that.$router.push({ path: '/' });
          // 登陆成功
          that.$message.showMsgBox({ type: 'success', content: '登陆成功' });
        } else {
          // 登陆失败
          that.$message.showMsgBox({ type: 'warning', content: '登陆失败' });
        }
      } else {
        // 登陆失败
        that.$message.showMsgBox({ type: 'warning', content: ob.message });
      }
      return ob;
    }).catch((ob) => {
      // console.log(ob);
      // 登陆失败
      that.$message.showMsgBox({ type: 'warning', content: '网络失败' });
      return { state: 201, message: '网络错误' };
    });
  },
  // 发送短信
  apiSendcode(that, ob) {
    return apiSendcode(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改密码
  apiSavepwd(that, ob) {
    return apiSavepwd(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改头像
  apiSaveheadportrait(that, ob) {
    return apiSaveheadportrait(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiOrderinfocalculate(that, ob) {
    return apiOrderinfocalculate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 修改发票抬头
  apiSaveinvoiceinfo(that, ob) {
    return apiSaveinvoiceinfo(ob).then(ob => {
      return ob;
    }).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiSaveinfoname(that, ob) {
    return apiSaveinfoname(ob).then(ob => {
      return ob;
    }).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 地图信息
  apiMapdata(that, ob) {
    return apiMapdata(ob).then(ob => {
      return {state:200 ,message:'获取成功',data:ob}
    }).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 项目信息
  apiProduct(that, ob) {
    return apiProduct(ob).then(ob => {
      return {state:200 ,message:'获取成功',data:ob}
    }).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiArticleinfo(that, ob) {
    return apiArticleinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 文章列表
  apiArticlelists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiArticlelists(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了apiWarehouseFilesModify
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.maxNum = ob.data.maxNum;// 最大数
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败'
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败'
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 文章列表
  apiWarehousebillsgoods(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    // 执行获取个人信息的请求
    return apiWarehousebillsgoods(obj).then((ob) => {
      if (ob.state === 200) {
        if (reload) {
          that.data = [];
        }
        // 请求成功了apiWarehouseFilesModify
        ob.data.list.forEach((item) => {
          that.data.push(item);
        });
        that.allPage = ob.data.totalPages;// 重置总页数
        that.page += 1;// 多加一页
        that.allNumber = ob.data.total;
        that.is_empty = false;// 为空
        that.maxNum = ob.data.maxNum;// 最大数
        that.loadingFun(2);// 关闭加载动画
      } else if (ob.state === 201) {
        // 没有更多了
        if (ob.data.totalPages === 0) {
          // 没有任何数据
          that.data = [];// 清空
          that.allPage = 1;// 重置总页数
          that.page = 1;// 重置当前页数
          that.is_empty = true;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        } else {
          // 没有任何数据
          that.allPage = ob.data.totalPages;// 重置总页数
          that.is_empty = false;// 为空
          that.loadingFun(3);// 没有更多了(不再请求)
        }
      } else {
        // 请求失败
        that.$message.showMsgBox({
          type: 'warning',
          content: '请求失败'
        });
        that.loadingFun(4);// 请求失败了(不再请求)
      }
      return ob;
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败'
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 获取商品分类导航
  apiGoodsnav(that, ob) {
    return apiGoodsnav(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 收藏操作
  apiDealercollectenter(that, ob) {
    return apiDealercollectenter(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 组合商品
  apiGoodsgrouplists(that, ob) {
    return apiGoodsgrouplists(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 组合详情
  apiGroupgoodsinfo(that, ob) {
    return apiGroupgoodsinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiGoodsgrouplistsall(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiGoodsgrouplists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            if(item.imgpath){
              item.imgpath = item.imgpath;
            }else{
              item.imgpath = '/static/images/kong.jpg';
            }
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败'
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }else{
        return {};
      }
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败'
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 商品详情
  apiGoodsinfo(that, ob) {
    return apiGoodsinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 商品列表
  apiGoodslists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiGoodslists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            if(item.imgpath){
              item.imgpath = that.ossImgDomain + item.imgpath;
            }else{
              item.imgpath = '/static/images/kong.jpg';
            }
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败'
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }else{
        return {};
      }
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败'
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  // 组合商品
  apiArticlelistsall(that, ob) {
    return apiArticlelists(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 商品列表
  apiGoodslistsall(that, ob) {
    return apiGoodslists(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiOrderinfo(that, ob) {
    return apiOrderinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiBillsinfo(that, ob) {
    return apiBillsinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiInvoiceapply(that, ob) {
    return apiInvoiceapply(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiHomeindex(that, ob) {
    return apiHomeindex(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiOrderdetailinfo(that, ob) {
    return apiOrderdetailinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 商品列表
  apiOrderinfolists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiOrderinfolists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败'
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }else{
       return {};
      }
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败'
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },


  apiOrdercataloglists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiOrdercataloglists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败'
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }else{
        return {};
      }
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败'
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  apiCrmdatamessagelists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmdatamessagelists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败'
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }else{
        return {};
      }
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败'
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },



  apiCrmdatacashbacklists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmdatacashbacklists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败'
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }else{
        return {};
      }
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败'
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiCrmdatacashbackloglists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiCrmdatacashbackloglists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败'
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }else{
        return {};
      }
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败'
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },




  apiWarehousebillsgoodscalculate(that, ob) {
    return apiWarehousebillsgoodscalculate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiOrdercataloginfo(that, ob) {
    return apiOrdercataloginfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 商品列表
  apiWarehousebillsgoodslists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiWarehousebillsgoodslists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败'
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }else{
        return {};
      }
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败'
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },

  // 商品列表
  apiInvoicelists(that, obj, reload = false) {
    // 请求中
    that.loadingFun(1);
    if (isNaN(that.repeatKey)) {
      that.repeatKey = 0;
    }
    that.repeatKey += 1;
    that.whereObj.repeatKey = that.repeatKey;
    // 执行获取个人信息的请求
    return apiInvoicelists(obj).then((ob) => {
      if (ob.data.repeatKey * 1 === that.repeatKey * 1) {
        if (ob.state === 200) {
          if (reload) {
            that.data = [];
          }
          // 请求成功了apiWarehouseFilesModify
          ob.data.list.forEach((item) => {
            that.data.push(item);
          });
          that.allPage = ob.data.totalPages;// 重置总页数
          that.page += 1;// 多加一页
          that.allNumber = ob.data.total;
          that.is_empty = false;// 为空
          that.maxNum = ob.data.maxNum;// 最大数
          that.loadingFun(2);// 关闭加载动画
        } else if (ob.state === 201) {
          // 没有更多了
          if (ob.data.totalPages === 0) {
            // 没有任何数据
            that.data = [];// 清空
            that.allPage = 1;// 重置总页数
            that.page = 1;// 重置当前页数
            that.is_empty = true;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          } else {
            // 没有任何数据
            that.allPage = ob.data.totalPages;// 重置总页数
            that.is_empty = false;// 为空
            that.loadingFun(3);// 没有更多了(不再请求)
          }
        } else {
          // 请求失败
          that.$message.showMsgBox({
            type: 'warning',
            content: '请求失败'
          });
          that.loadingFun(4);// 请求失败了(不再请求)
        }
        return ob;
      }else{
        return {};
      }
    }).catch((ob) => {
      // 请求失败
      that.$message.showMsgBox({
        type: 'warning',
        content: '请求失败'
      });
      that.loadingFun(4);// 关闭加载动画 - 请求失败了(不再请求)
      return ob;
    });
  },
  apiInvoiceinfo(that, ob) {
    return apiInvoiceinfo(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiOrdercatalog(that, ob) {
    return apiOrdercatalog(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiOrdercatalogstate(that, ob) {
    return apiOrdercatalogstate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiWechatpay(that, ob) {
    return apiWechatpay(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiPaypalurl(that, ob) {
    return apiPaypalurl(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 收银台
  apiCalculatepaydata(that, ob) {
    return apiCalculatepaydata(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCalculatepayaddcar(that, ob) {
    return apiCalculatepayaddcar(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiCalculatepaysetaddcar(that, ob) {
    return apiCalculatepaysetaddcar(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  // 解析登录token
  apiApilogincalculatetokenid(that, ob) {
    return apiApilogincalculatetokenid(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiApilogincodecollate(that, ob) {
    return apiApilogincodecollate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiApiloginDcmoneycollate(that, ob) {
    return apiApiloginDcmoneycollate(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  },
  apiActivityinfoalls(that, ob) {
    return apiActivityinfoalls(ob).then(ob => ob).catch(ob => ({ state: 201, message: '网络错误' }));
  }
};



// WEBPACK FOOTER //
// ./src/util/resultcommons.js